import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { Logo } from "../components/Logo";

export function AppShell() {
  const { session } = useAuth();
  return (
    <div className="shell">
      <header className="topbar">
        <div className="topbar-inner">
          <NavLink to="/" className="wordmark" aria-label="SoundLayer home">
            <Logo size={28} />
            <span>
              Sound<b>Layer</b>
            </span>
          </NavLink>
          {session && (
            <nav className="nav" aria-label="Primary">
              <NavLink to="/" end>
                Create
              </NavLink>
              <NavLink to="/library">Library</NavLink>
              <NavLink to="/account">Account</NavLink>
            </nav>
          )}
        </div>
      </header>
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
